/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeCreateApiKeyResponse,
  ApiEnvelopeDeleteApiKeyResponse,
  ApiEnvelopeListApiKeysResponse,
  CreateApiKeyRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type apiKeyListResponse200 = {
  data: ApiEnvelopeListApiKeysResponse
  status: 200
}

export type apiKeyListResponse401 = {
  data: ApiEnvelopeListApiKeysResponse
  status: 401
}

export type apiKeyListResponse403 = {
  data: ApiEnvelopeListApiKeysResponse
  status: 403
}

export type apiKeyListResponseSuccess = (apiKeyListResponse200) & {
  headers: Headers;
};
export type apiKeyListResponseError = (apiKeyListResponse401 | apiKeyListResponse403) & {
  headers: Headers;
};

export type apiKeyListResponse = (apiKeyListResponseSuccess | apiKeyListResponseError)

export const getApiKeyListUrl = () => {




  return `/api/apikeys`
}

export const useApiKeyListHook = (): ( options?: RequestInit) => Promise<apiKeyListResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getApiKeyListUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type apiKeyCreateResponse200 = {
  data: ApiEnvelopeCreateApiKeyResponse
  status: 200
}

export type apiKeyCreateResponse400 = {
  data: ApiEnvelopeCreateApiKeyResponse
  status: 400
}

export type apiKeyCreateResponse401 = {
  data: ApiEnvelopeCreateApiKeyResponse
  status: 401
}

export type apiKeyCreateResponse403 = {
  data: ApiEnvelopeCreateApiKeyResponse
  status: 403
}

export type apiKeyCreateResponseSuccess = (apiKeyCreateResponse200) & {
  headers: Headers;
};
export type apiKeyCreateResponseError = (apiKeyCreateResponse400 | apiKeyCreateResponse401 | apiKeyCreateResponse403) & {
  headers: Headers;
};

export type apiKeyCreateResponse = (apiKeyCreateResponseSuccess | apiKeyCreateResponseError)

export const getApiKeyCreateUrl = () => {




  return `/api/apikeys`
}

export const useApiKeyCreateHook = (): (createApiKeyRequest?: CreateApiKeyRequest, options?: RequestInit) => Promise<apiKeyCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (createApiKeyRequest?: CreateApiKeyRequest, options?: RequestInit) => {

        return customFetcher(getApiKeyCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createApiKeyRequest)
  }
);
      }
  }


export type apiKeyDeleteResponse200 = {
  data: ApiEnvelopeDeleteApiKeyResponse
  status: 200
}

export type apiKeyDeleteResponse401 = {
  data: ApiEnvelopeDeleteApiKeyResponse
  status: 401
}

export type apiKeyDeleteResponse403 = {
  data: ApiEnvelopeDeleteApiKeyResponse
  status: 403
}

export type apiKeyDeleteResponse404 = {
  data: ApiEnvelopeDeleteApiKeyResponse
  status: 404
}

export type apiKeyDeleteResponseSuccess = (apiKeyDeleteResponse200) & {
  headers: Headers;
};
export type apiKeyDeleteResponseError = (apiKeyDeleteResponse401 | apiKeyDeleteResponse403 | apiKeyDeleteResponse404) & {
  headers: Headers;
};

export type apiKeyDeleteResponse = (apiKeyDeleteResponseSuccess | apiKeyDeleteResponseError)

export const getApiKeyDeleteUrl = (id: string,) => {




  return `/api/apikeys/${id}`
}

export const useApiKeyDeleteHook = (): (id: string, options?: RequestInit) => Promise<apiKeyDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getApiKeyDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


